(function () {
  function collectLineItemProperties(form) {
    const properties = {};
    const formData = new FormData(form);

    formData.forEach((value, key) => {
      if (!key.startsWith('properties[') || value == null || value === '') return;
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });

    form.querySelectorAll('.product-form__input [name^="properties"]').forEach((input) => {
      if (input.type === 'file') return;
      if (input.value == null || input.value === '') return;
      const match = input.name.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = input.value;
    });

    return properties;
  }

  function setLoading(formComponent, isLoading) {
    const submitButton = formComponent.querySelector('.add-to-cart-button');
    const spinner = submitButton?.querySelector('.loading__spinner');
    const productInfo = formComponent.closest('product-info');
    const sectionId = productInfo?.dataset.section || productInfo?.dataset.originalSection;
    const stickyAddButton = sectionId
      ? document.getElementById(`StickyCart-ProductSubmitButton-${sectionId}`)
      : null;
    const stickySpinner = stickyAddButton?.querySelector('.loading__spinner');

    if (!submitButton) return;

    if (isLoading) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
      spinner?.classList.remove('hidden');
      if (stickyAddButton && stickySpinner) {
        stickyAddButton.classList.add('loading');
        stickySpinner.classList.remove('hidden');
      }
      return;
    }

    submitButton.classList.remove('loading');
    submitButton.removeAttribute('aria-disabled');
    spinner?.classList.add('hidden');
    if (stickyAddButton && stickySpinner) {
      stickyAddButton.classList.remove('loading');
      stickySpinner.classList.add('hidden');
    }
  }

  function showFormError(formComponent, message) {
    const wrapper = formComponent.querySelector('.product-form__error-message-wrapper');
    const errorEl = formComponent.querySelector('.product-form__error-message');

    if (wrapper && errorEl) {
      wrapper.toggleAttribute('hidden', !message);
      if (message) errorEl.textContent = message;
      return;
    }

    if (message) window.alert(message);
  }

  async function addFamilySetToCart(formComponent, addon, form) {
    const kidsVariantId = parseInt(addon.dataset.kidsVariantId, 10);
    const mainVariantId = parseInt(form.querySelector('[name="id"]')?.value, 10);
    const qtyField = form.querySelector('[name="quantity"]');
    const mainQty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    const kidsQty = parseInt(addon.querySelector('[data-cj-family-addon-qty]')?.value, 10) || 1;
    const properties = collectLineItemProperties(form);

    if (!kidsVariantId || !mainVariantId) return false;

    const items = [
      {
        id: mainVariantId,
        quantity: mainQty,
        properties: Object.keys(properties).length ? properties : undefined,
      },
      {
        id: kidsVariantId,
        quantity: kidsQty,
      },
    ];

    const payload = { items };
    const cart = document.querySelector('cart-drawer');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    const addUrlBase = window.routes?.cart_add_url || '/cart/add';
    const addUrl = addUrlBase.endsWith('.js') ? addUrlBase : `${addUrlBase}.js`;

    const response = await fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (data.status || data.message) {
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'couple-janamaz-family-addon',
          productVariantId: mainVariantId,
          errors: data.errors || data.description,
          message: data.message,
        });
      }
      showFormError(formComponent, data.description || data.message || 'Unable to add items to cart.');
      return false;
    }

    if (response.ok) window['clean-commerce']?.added(data, items, 'legacy-family-addon');
    if (typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'couple-janamaz-family-addon',
        productVariantId: mainVariantId,
        cartData: data,
      });
    }

    if (!cart) {
      window.location = window.routes?.cart_url || '/cart';
      return true;
    }

    if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    const openAddon = (addon) => {
      const opener = addon?.openWithCartResponse || window.CartAddonDrawer?.openWithCartResponse;
      if (opener) {
        opener.call(window.CartAddonDrawer || addon, data);
      } else if (typeof cart.renderContents === 'function') {
        cart.renderContents(data);
      }
    };
    if (window.__ensureCartAddonDrawer) {
      window.__ensureCartAddonDrawer().then(openAddon).catch(() => openAddon(null));
    } else {
      openAddon(window.CartAddonDrawer);
    }
    return true;
  }

  function bindAddon(addon) {
    const formComponent = addon.closest('product-form-component');
    if (!formComponent || formComponent.dataset.cjFamilyAddonBound === 'true') return;

    const form = formComponent.querySelector('form');
    if (!form) return;

    formComponent.dataset.cjFamilyAddonBound = 'true';

    form.addEventListener(
      'submit',
      async (event) => {
        const toggle = addon.querySelector('[data-cj-family-addon-toggle]');
        if (!toggle?.checked) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (formComponent.querySelector('.add-to-cart-button')?.getAttribute('aria-disabled') === 'true') {
          return;
        }

        setLoading(formComponent, true);
        showFormError(formComponent, false);

        try {
          await addFamilySetToCart(formComponent, addon, form);
        } catch (error) {
          console.error(error);
          showFormError(formComponent, 'Something went wrong. Please try again.');
        } finally {
          setLoading(formComponent, false);
        }
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('[data-couple-janamaz-addon]').forEach(bindAddon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
